import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    guiasEnvio:[],
  },
  mutations: {

   
    getGuiasDeEnvio(state,datos) {
      state.guiasEnvio = datos;
    },


  },
  actions: {

    async updateGuiasDeEnvio({
      commit,
    }, idEnv) {
      try {
        const res = await api.updateGuiasDeEnvio(idEnv);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          // commit('updateGuiasDeEnvio', res.data);
          return [true];
        } return [false,res.data.INFO.validacion];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async getGuiasDeEnvio({
      commit,
    }, idEnv) {
      try {
        const res = await api.getGuiasDeEnvio(idEnv);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getGuiasDeEnvio', res.data.GUIAS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },



  },
};
